export default __webpack_public_path__ + "static/media/o.f905e300.jpg";